export default {
  id: 'slack_promote_content_shares',
  title: 'Promote content shares',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'MANY_CONTENT' ],
  description: 'Send up to 4 selected pieces of content to your employees so they can easily share them across their network.',
  body: {
    blocks: [
      {
        text: {
          text: '[[INPUT_INTRODUCTION_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        type: 'blocks',
        key: 'BLOCK_CONTENT',
      },
      {
        text: {
          text: '[[INPUT_END_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      }
    ]
  },
  blocks: {
    BLOCK_CONTENT: (contentShareType = 'default') => ([
      {
        type: 'divider'
      },
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: '*{{CONTENT_[ID]_TITLE}}*\n\n{{CONTENT_[ID]_DESCRIPTION}}'
        },
        accessory: {
          type: 'image',
          image_url: '{{CONTENT_[ID]_IMAGE_URL}}',
          alt_text: '{{CONTENT_[ID]_TITLE}}'
        }
      },
      ...(contentShareType !== 'linkedin-only' ? [ {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: '*Suggested Share Text:*\n\n```{{CONTENT_[ID]_SHARE_TEXT}}```'
        }
      },
      {
        type: 'context',
        elements: [
          {
            type: 'mrkdwn',
            text: '👆 Copy the text above to share with your network'
          }
        ]
      } ] : []),
      {
        type: 'actions',
        elements: [
          {
            type: 'button',
            text: {
              type: 'plain_text',
              text: 'Share on LinkedIn',
              emoji: true
            },
            url: '{{CONTENT_[ID]_LINKEDIN_SHARE_LINK}}',
          },
          ...(contentShareType !== 'linkedin-only' ? [ {
            type: 'button',
            text: {
              type: 'plain_text',
              text: 'Share on Facebook',
              emoji: true
            },
            url: '{{CONTENT_[ID]_FACEBOOK_SHARE_LINK}}',
          },
          {
            type: 'button',
            text: {
              type: 'plain_text',
              text: 'Share on X',
              emoji: true
            },
            url: '{{CONTENT_[ID]_TWITTER_SHARE_LINK}}',
          } ] : [])
        ]
      },
      ...(contentShareType !== 'linkedin-only' ? [ {
        type: 'actions',
        elements: [
          {
            type: 'button',
            text: {
              type: 'plain_text',
              text: 'Share on Messenger',
              emoji: true
            },
            url: '{{CONTENT_[ID]_MESSENGER_SHARE_LINK}}'
          },
          {
            type: 'button',
            text: {
              type: 'plain_text',
              text: 'Share on WhatsApp',
              emoji: true
            },
            url: '{{CONTENT_[ID]_WHATSAPP_SHARE_LINK}}'
          },
          {
            type: 'button',
            text: {
              type: 'plain_text',
              text: 'Copy Share Link',
              emoji: true
            },
            url: '{{CONTENT_[ID]_COPY_SHARE_LINK}}'
          }
        ]
      } ] : [])
    ])
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following pieces of content with your network to win rewards! ...',
      defaultValue: 'Share the following pieces of content with your network to win rewards!',
      type: 'HTML'
    },
    INPUT_END_TEXT: {
      label: 'Text at the end',
      placeholder: 'Come back to the platform to get more rewards by every action you take! {{PLATFORM_LINK}}...',
      defaultValue: 'Come back to the platform to get more rewards by every action you take! {{PLATFORM_LINK}}',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/promoteContentShares.js